"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var link_1 = require("@syl-editor/lib/dist/lib/formats/link");
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var card_1 = require("../../card");
require("./index.css");
var modal_1 = require("../../component/modal");
var validateHrefFn;
var Icon = (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "20", viewBox: "0 0 24 24", width: "20" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" })));
var PLUGIN_NAME = 'link';
exports.setLinkConfiguration = function (_a) {
    var validateHref = _a.validateHref;
    validateHrefFn = validateHref;
};
var LinkTooltip = function (props) {
    var _a = react_1.useState('hidden'), visibility = _a[0], setVisibility = _a[1];
    var tipRef = react_1.useRef(null);
    var _b = react_1.useState({}), position = _b[0], setPosition = _b[1];
    react_1.useEffect(function () {
        // ensure tooltip in visible area
        if (!tipRef.current)
            return;
        var rect = props.getBoundingClientRect();
        var $edit = props.adapter.view.dom;
        var editRect = props.adapter.view.dom.getBoundingClientRect();
        var width = tipRef.current.offsetWidth;
        var computedPos = { left: rect.left, top: rect.top - rect.height - 2 };
        if (rect.left + width > editRect.right) {
            computedPos.left = editRect.width - width - 2;
        }
        if (computedPos.top + (editRect.top - $edit.offsetTop) < 0) {
            computedPos.top = rect.bottom + 2;
        }
        setPosition(computedPos);
        setVisibility('visible');
    }, [tipRef]);
    return (react_1.default.createElement("span", { contentEditable: false, className: "syl-link-tooltip-wrapper syl-link-tooltip", style: __assign({ visibility: visibility }, position), ref: tipRef, onMouseEnter: props.cancelHideTooltip, onMouseLeave: props.hideTooltipWhenLeaveAsync },
        react_1.default.createElement("a", { href: props.attrs.href, target: "_blank" }, props.attrs.href)));
};
var LinkComponent = /** @class */ (function (_super) {
    __extends(LinkComponent, _super);
    function LinkComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hiddenTooltipTimer = null;
        _this.state = {
            showTooltip: false
        };
        _this.showTooltipOnHover = function () {
            if (!_this.props.adapter.editable)
                return;
            _this.cancelHideTooltip();
            if (_this.state.showTooltip === false) {
                _this.setState({ showTooltip: true });
            }
        };
        _this.hideTooltipWhenLeaveAsync = function () {
            if (_this.state.showTooltip === true) {
                _this.hiddenTooltipTimer = window.setTimeout(function () { return _this.setState({ showTooltip: false }); }, 300);
            }
        };
        _this.cancelHideTooltip = function () {
            if (typeof _this.hiddenTooltipTimer === 'number') {
                window.clearTimeout(_this.hiddenTooltipTimer);
                _this.hiddenTooltipTimer = null;
            }
        };
        // 阻止 a 标签跳转事件
        _this.preventDefaultEvent = function (e) {
            if (!_this.props.adapter.editable)
                return;
            e.preventDefault();
            e.stopPropagation();
            return false;
        };
        return _this;
    }
    LinkComponent.prototype.render = function () {
        var showTooltip = this.state.showTooltip;
        return [
            react_1.default.createElement("a", { key: "link-" + this.props.attrs.text, href: this.props.attrs.href, target: "_blank", rel: "nofollow", className: "syl-link", onMouseEnter: this.showTooltipOnHover, onMouseLeave: this.hideTooltipWhenLeaveAsync, onClick: this.preventDefaultEvent }, this.props.attrs.text),
            showTooltip &&
                react_dom_1.default.createPortal(react_1.default.createElement(LinkTooltip, __assign({ key: "linktooltip-" + this.props.attrs.text, hideTooltipWhenLeaveAsync: this.hideTooltipWhenLeaveAsync, cancelHideTooltip: this.cancelHideTooltip }, this.props)), this.props.adapter.root)
        ];
    };
    return LinkComponent;
}(react_1.default.PureComponent));
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ViewMap = {
            template: LinkComponent
        };
        _this.renderer = _this.mount({ name: 'link' });
        return _this;
    }
    Link = __decorate([
        core_utilities_1.configuration(__assign({}, link_1.Link.configuration))
    ], Link);
    return Link;
}(card_1.InlineCard));
exports.Link = Link;
var InsertType;
(function (InsertType) {
    InsertType["Insert"] = "insert";
    InsertType["Replace"] = "replace";
    InsertType["Selection"] = "selection"; // 选中文字
})(InsertType || (InsertType = {}));
var LinkModal = /** @class */ (function (_super) {
    __extends(LinkModal, _super);
    function LinkModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            text: '',
            href: '',
            pos: 0,
            insertType: InsertType.Insert,
            errorText: ''
        };
        _this.handleClickOpen = function () {
            _this.setState({ open: true });
        };
        _this.handleClose = function () {
            _this.setState({ open: false });
        };
        _this.handleConfirm = function () {
            var _a = _this.state, text = _a.text, href = _a.href, insertType = _a.insertType, pos = _a.pos;
            var _b = _this.props, editor = _b.editor, validateHref = _b.validateHref;
            if (!editor)
                return;
            var newHref = href;
            if (validateHref) {
                var _c = validateHref(href), error = _c.error, result = _c.text, hrefAfterValidate = _c.href;
                // 校验通过
                if (error === false) {
                    newHref = hrefAfterValidate || href;
                }
                else {
                    _this.setState({
                        errorText: result
                    });
                    return;
                }
            }
            var _d = editor.getSelection(), index = _d.index, length = _d.length;
            switch (insertType) {
                case InsertType.Insert:
                    _this.props.insert({ text: text, href: newHref });
                    break;
                case InsertType.Replace:
                    editor.updateCardAttrs(pos, { text: text, href: newHref });
                    break;
                case InsertType.Selection:
                    editor.replace({ type: PLUGIN_NAME, attrs: { text: text, href: newHref } }, { index: index, length: length });
                    break;
                default:
                    break;
            }
            setTimeout(function () {
                editor.focus();
                editor.setSelection({ index: index + 1, length: 0 });
            });
            _this.setState({ open: false });
        };
        _this.onEnterKeyup = function (e) {
            if (e.keyCode === 13 || e.key === 'Enter')
                _this.handleConfirm();
        };
        return _this;
    }
    LinkModal.prototype.render = function () {
        var _this = this;
        var _a = this.state, text = _a.text, href = _a.href, insertType = _a.insertType, errorText = _a.errorText;
        var editor = this.props.editor;
        var locale = editor.configurator.getLocaleValue(PLUGIN_NAME);
        return (react_1.default.createElement(modal_1.Modal, { isOpen: this.state.open, onClose: this.handleClose },
            react_1.default.createElement(modal_1.ModalTitle, null, insertType === InsertType.Replace
                ? locale.editLinkTitle || '插入链接'
                : locale.insertLinkTitle || '修改链接'),
            react_1.default.createElement(modal_1.ModalContent, null,
                react_1.default.createElement("input", { placeholder: locale.textPlaceholder || '链接文字', name: "text", value: text, onChange: function (e) {
                        return _this.setState({
                            text: e.target.value
                        });
                    }, autoFocus: true, onKeyUp: this.onEnterKeyup }),
                react_1.default.createElement("input", { placeholder: locale.linkPlaceholder || '链接地址', name: "href", value: href, onChange: function (e) {
                        return _this.setState({
                            href: e.target.value
                        });
                    }, onKeyUp: this.onEnterKeyup }),
                react_1.default.createElement("div", { className: "form-explain" }, errorText ? errorText : '')),
            react_1.default.createElement(modal_1.ModalFooter, null,
                react_1.default.createElement("button", { onClick: this.handleClose, color: "primary", type: "button" }, locale.cancelText || '取消'),
                react_1.default.createElement("button", { onClick: this.handleConfirm, color: "primary", type: "button" }, locale.okText || '确认'))));
    };
    return LinkModal;
}(react_1.default.PureComponent));
var LinkController = /** @class */ (function (_super) {
    __extends(LinkController, _super);
    function LinkController(editor, store, props) {
        var _this = _super.call(this, editor, store) || this;
        _this.modal = null;
        _this.name = PLUGIN_NAME;
        _this.validateHref = null;
        _this.eventHandler = {
            handleClickOn: function (editor, view, pos, node, nodePos, event) {
                if (!editor.editable)
                    return false;
                if (node.type.name === PLUGIN_NAME && _this.modal) {
                    // debugger;
                    event.preventDefault();
                    var _a = node.attrs, href = _a.href, text = _a.text;
                    _this.modal.setState({
                        text: text,
                        href: href,
                        pos: pos,
                        insertType: InsertType.Replace,
                        open: true,
                        errorText: ''
                    });
                }
                return false;
            }
        };
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            icon: Icon,
            handler: function (editor) {
                if (_this.modal) {
                    // 检查是否有选中
                    var selectionObj = window.getSelection();
                    var text = selectionObj ? selectionObj.toString() : '';
                    var insertType = InsertType.Insert;
                    if (text) {
                        insertType = InsertType.Selection;
                    }
                    _this.modal.setState({
                        text: text,
                        insertType: insertType,
                        open: true,
                        href: '',
                        pos: 0,
                        errorText: ''
                    });
                }
            }
        };
        _this.insert = function (attrs) {
            _this.editor.insertCard(PLUGIN_NAME, attrs);
        };
        _this.validateHref = props.validateHref;
        var extraDom = (react_1.default.createElement(LinkModal, { ref: function (el) {
                if (el) {
                    _this.modal = el;
                }
            }, validateHref: _this.validateHref || validateHrefFn, insert: _this.insert, editor: editor }));
        _this.modalContainer = document.createElement('div');
        document.body.appendChild(_this.modalContainer);
        react_dom_1.default.render(extraDom, _this.modalContainer);
        return _this;
    }
    LinkController.prototype.editorWillUnmount = function () {
        react_dom_1.default.unmountComponentAtNode(this.modalContainer);
    };
    return LinkController;
}(core_utilities_1.SylController));
exports.LinkController = LinkController;
//# sourceMappingURL=link.js.map